import Carousel from "nuka-carousel";
import './Slideshow.css'

const Slideshow = () => {
    return (
        <Carousel autoplay="true" wrapAround={true} defaultControlsConfig={{
            nextButtonStyle: {'display':'none'},
            prevButtonStyle: {'display':'none'},
            pagingDotsStyle: {fill: 'white'}
          }}>
            <img src={process.env.PUBLIC_URL + '/images/home/new-ep-banner.jpg'} className="App-logo" alt="logo" />
            <img src={process.env.PUBLIC_URL + '/images/home/sap-new-banner.jpg'} className="App-logo" alt="logo" />
            <img src={process.env.PUBLIC_URL + 'images/home/oracle-new-banner.jpg'} className="App-logo" alt="logo" />
            <img src={process.env.PUBLIC_URL + 'images/home/sfdc-new-banner.jpg'} className="App-logo" alt="logo" />            
        </Carousel>
    )   
}

export default Slideshow; 

